module.exports = __webpack_public_path__ + "bullet_minus.c93f19cf6dba4c68e8db618b45de903f.png";